import React from "react";
import { Grid } from "@material-ui/core";
import { colors } from "../theme";
import { useAuth0 } from "../auth/react-auth0-wrapper";
var CenterContainer = function CenterContainer(_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style;
  var _useAuth = useAuth0(),
    isV2Ui = _useAuth.isV2Ui;
  return React.createElement("div", {
    style: {
      width: "1396px",
      maxWidth: "1396x",
      paddingLeft: isV2Ui ? "40px" : "270px",
      height: "100%",
      display: "flex"
    }
  }, React.createElement(Grid, {
    item: true,
    xs: 12,
    className: className,
    style: Object.assign({
      backgroundColor: colors.grey,
      padding: "1em 2em"
    }, style)
  }, children), React.createElement(Grid, {
    item: true,
    xs: false,
    md: true
  }));
};
export default CenterContainer;